// utils/fileDisplay.js
export const EXT_ICON = {
  image: "🖼️", pdf: "📄", doc: "📝", ppt: "📊", xls: "📈", txt: "📃", csv: "📑", zip: "🗜️", other: "📦"
};

export function extFromName(name="") {
  const m = name.toLowerCase().match(/\.([a-z0-9]+)$/);
  return m ? m[1] : "";
}

export function classifyByExt(ext) {
  if (["jpg","jpeg","png","gif","bmp","webp","svg","heic"].includes(ext)) return {kind:"image",  label: ext.toUpperCase()};
  if (ext === "pdf") return {kind:"pdf", label:"PDF"};
  if (["doc","docx","rtf","odt","pages"].includes(ext)) return {kind:"doc", label: ext.toUpperCase()};
  if (["ppt","pptx","key"].includes(ext)) return {kind:"ppt", label: ext.toUpperCase()};
  if (["xls","xlsx","ods","numbers"].includes(ext)) return {kind:"xls", label: ext.toUpperCase()};
  if (["csv"].includes(ext)) return {kind:"csv", label:"CSV"};
  if (["txt","md","log"].includes(ext)) return {kind:"txt", label: ext.toUpperCase()};
  if (["zip","rar","7z"].includes(ext)) return {kind:"zip", label: ext.toUpperCase()};
  return {kind:"other", label: ext ? ext.toUpperCase() : "FILE"};
}

export function humanSize(bytes=0) {
  if (bytes === 0) return "0 B";
  const k=1024, units=["B","KB","MB","GB","TB"];
  const i=Math.floor(Math.log(bytes)/Math.log(k));
  return `${(bytes/Math.pow(k,i)).toFixed(1)} ${units[i]}`;
}

export function iconFor(kind) {
  return EXT_ICON[kind] || EXT_ICON.other;
}
